module.exports = __webpack_public_path__ + "img/38975343b586296e9b73e6b56cc3ec5d.svg";